import fgInput from './components/UIComponents/Inputs/formGroupInput.vue';
import DropDown from './components/UIComponents/Dropdown.vue';
import Checkbox from './components/UIComponents/Inputs/Checkbox.vue';
import Radio from './components/UIComponents/Inputs/Radio.vue';

import {Collapse, CollapseItem, DatePicker} from 'element-ui';
import VueTabs from 'vue-nav-tabs';

/**
 * You can register global components here and use them as a plugin in your main Vue instance
 * Ideally, only small components that are re-used many times across your application should be registered here.
 * For plugins and bigger components local registration is preferable because it will allow you to do code splitting easier :)
 */

import FArray from './components/Dashboard/Views/Forms/Fields/f-array.vue';
import FInput from './components/Dashboard/Views/Forms/Fields/f-input.vue';
import FTextarea from './components/Dashboard/Views/Forms/Fields/f-textarea.vue';
import FCheckbox from './components/Dashboard/Views/Forms/Fields/f-checkbox.vue';
import FDatetime from './components/Dashboard/Views/Forms/Fields/f-datetime.vue';
import FSelect from './components/Dashboard/Views/Forms/Fields/f-select.vue';
import FTags from './components/Dashboard/Views/Forms/Fields/f-tags.vue';
import FSchema from './components/Dashboard/Views/Forms/Fields/f-schema.vue';
import FTable from './components/Dashboard/Views/Forms/Fields/f-table.vue';
import FLabel from './components/Dashboard/Views/Forms/Fields/f-label.vue';
import FId from './components/Dashboard/Views/Forms/Fields/f-id.vue';
import FRadio from './components/Dashboard/Views/Forms/Fields/f-radio.vue';
import FLink from './components/Dashboard/Views/Forms/Fields/f-link.vue';
import FImg from './components/Dashboard/Views/Forms/Fields/f-img.vue';
import FFile from './components/Dashboard/Views/Forms/Fields/f-file.vue';
import FButton from './components/Dashboard/Views/Forms/Fields/f-button.vue';
import FI18n from './components/Dashboard/Views/Forms/Fields/f-i18n.vue';
import FJson from './components/Dashboard/Views/Forms/Fields/f-json.vue';
import FHtml from './components/Dashboard/Views/Forms/Fields/f-html.vue';

const GlobalComponents = {
  install(Vue) {
    Vue.use(VueTabs);
    Vue.use(Collapse);
    Vue.use(CollapseItem);
    Vue.use(DatePicker);

    Vue.component(fgInput.name, fgInput);
    Vue.component(DropDown.name, DropDown);
    Vue.component(Checkbox.name, Checkbox);
    Vue.component(Radio.name, Radio);
    // dynamic fields
    Vue.component(FArray.name, FArray);
    Vue.component(FInput.name, FInput);
    Vue.component(FTextarea.name, FTextarea);
    Vue.component(FCheckbox.name, FCheckbox);
    Vue.component(FDatetime.name, FDatetime);
    Vue.component(FSelect.name, FSelect);
    Vue.component(FTags.name, FTags);
    Vue.component(FSchema.name, FSchema);
    Vue.component(FTable.name, FTable);
    Vue.component(FLabel.name, FLabel);
    Vue.component(FId.name, FId);
    Vue.component(FRadio.name, FRadio);
    Vue.component(FLink.name, FLink);
    Vue.component(FImg.name, FImg);
    Vue.component(FFile.name, FFile);
    Vue.component(FButton.name, FButton);
    Vue.component(FI18n.name, FI18n);
    Vue.component(FJson.name, FJson);
    Vue.component(FHtml.name, FHtml);
  },
};

export default GlobalComponents;



// WEBPACK FOOTER //
// ./src/gloablComponents.js